import { getUserDetails } from "./auth";

export const getAdminId = () => {
  const user_details = getUserDetails() || {};

  if (user_details.role === "admin") {
    return user_details.id || null;
  } else {
    return user_details.admin_id || null;
  }
};

export const getRegisterId = () => {
  const user_details = getUserDetails() || {};
  return user_details.id;
};

export const getRole = () => {
  const user_details = getUserDetails() || {};
  return user_details.role;
};
